import {
  ERROR_KEY,
  SNACKBAR_404_MSG,
  SNACKBAR_500_MSG,
  SNACKBAR_400_MSG,
  SNACKBAR_SUCCESS_MSG,
  SNACKBAR_DEFAULT_MSG,
  SUCCESS_KEY,
  SNACKBAR_401_MSG,
  SNACKBAR_403_MSG,
  SNACKBAR_409_MSG,
  SNACKBAR_201_MSG,
  SNACKBAR_204_MSG,
} from '../constants';

const ErrorSwitchCase = (response) => {
  const responseStatus = response?.status;
  const message = response?.message;
  const referenceResponseObject = {
    ...response,
    // data: response.data,
    status: responseStatus,
    isError:
      responseStatus === 200 || responseStatus === 201 || responseStatus === 204
        ? false
        : true,
  };
  if (referenceResponseObject.isError === true) console.log(response);

  switch (responseStatus) {
    case 200:
      return {
        ...referenceResponseObject,
        type: SUCCESS_KEY,
        message: message || SNACKBAR_SUCCESS_MSG,
      };
    case 201:
      return {
        ...referenceResponseObject,
        type: SUCCESS_KEY,
        message: message || SNACKBAR_201_MSG,
      };
    case 204:
      return {
        ...referenceResponseObject,
        type: SUCCESS_KEY,
        message: message || SNACKBAR_204_MSG,
      };
    case 400:
      return {
        ...referenceResponseObject,
        type: ERROR_KEY,
        message: message || SNACKBAR_400_MSG,
      };
    case 401:
      return {
        ...referenceResponseObject,
        type: ERROR_KEY,
        message: message || SNACKBAR_401_MSG,
      };
    case 403:
      return {
        ...referenceResponseObject,
        type: ERROR_KEY,
        message: message || SNACKBAR_403_MSG,
      };

    case 404:
      return {
        ...referenceResponseObject,
        type: ERROR_KEY,
        message: message || SNACKBAR_404_MSG,
      };
    case 409:
      return {
        ...referenceResponseObject,
        type: ERROR_KEY,
        message: message || SNACKBAR_409_MSG,
      };
    case 500:
      return {
        ...referenceResponseObject,
        type: ERROR_KEY,
        message: message || SNACKBAR_500_MSG,
      };
    default:
      return {
        ...referenceResponseObject,
        type: ERROR_KEY,
        message: message || SNACKBAR_DEFAULT_MSG,
      };
  }
};

export default ErrorSwitchCase;
